module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "w98"
  }, [_c('div', {
    staticClass: "crumb"
  }, [_c('span', [_c('router-link', {
    attrs: {
      "to": "/Help"
    }
  }, [_vm._v("帮助")]), _vm._v("  > ")], 1), _vm._v(" "), _c('span', [_vm._v("运行环境")])]), _vm._v(" "), _c('help-Menu'), _vm._v(" "), _vm._m(0)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rightContent"
  }, [_c('div', {
    staticClass: "runMessage"
  }, [_c('p', {
    staticClass: "text"
  }, [_vm._v("系统运行所需的硬件配置:")]), _vm._v(" "), _c('p', [_vm._v("内存：8G")]), _vm._v(" "), _c('p', [_vm._v("CPU：3.0GHz")]), _vm._v(" "), _c('p', [_vm._v("硬盘：500G")]), _vm._v(" "), _c('p', [_vm._v("分辨率：1280*1024以上")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("软件环境：")]), _vm._v(" "), _c('p', [_vm._v("a）服务端：")]), _vm._v(" "), _c('p', [_vm._v("操作系统：Centos 2.6.32-431.el6.x86_64；WindowServer 2008；")]), _vm._v(" "), _c('p', [_vm._v("Web服务器：Tomcat 7.0")]), _vm._v(" "), _c('p', [_vm._v("数据库：Oracle 11.2.0.4.  64bit Production ")]), _vm._v(" "), _c('p', [_vm._v("b) 应用终端：")]), _vm._v(" "), _c('p', [_vm._v("PC 端操作系统为Window7及以上 、Mac；")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("网络条件：")]), _vm._v(" "), _c('p', [_vm._v("网络架构：B/S架构。")]), _vm._v(" "), _c('p', [_vm._v("网络类型：广域网。")]), _vm._v(" "), _c('p', [_vm._v("互联网下载速度不低于500k/s。")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-3c1de509","hasScoped":true}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/moudle/RunEnvironment/RunEnvironment.vue
// module id = 555
// module chunks = 1 2 3 4 5 6 7 8